import { defineStore } from "pinia";

export const useAccountStore = defineStore("account", {
  state: () => ({
    id : null,

    accessToken: null,

    user: null,

    role: null,

    perusahaan: null,

    initialized: false,

    loading: false,

    isLoggedIn : false,

    detailUser : null
  }),

  actions: {
    setSession(token, user) {
      this.accessToken = token;

      this.user = user;

      this.initialized = true;
    },

    setUser(data) {
      this.id = data.id;

      this.user = data.user;

      this.perusahaan = data.perusahaan;

      this.detailUser = data.detailUser;

      this.role = data.role;

      this.initialized = true;

      this.isLoggedIn = true
    },

    clearSession() {
      this.accessToken = null;

      this.user = null;

      this.role = null;

      this.perusahaan = null;

      this.initialized = false;

      this.isLoggedIn = false;
    },

    startLoading() {
      this.loading = true;
    },

    finishLoading() {
      this.loading = false;
    },
  },
});
